module.exports = __webpack_public_path__ + "static/permission-management-d71b1bbed4359ca52df7d76f60a7aca8.png";